import { getBase64FileSize } from './getBase64FileSize';

export type ParsedBase64EncodedFileType = {
	size: number | null;
	mimeType: string | null;
	base64content: string | null;
};

export const parseBase64String = (file: string): ParsedBase64EncodedFileType => {
	const mimeType = file.match(/[^:]\w+\/[\w-+\d.]+(?=;)/)?.[0] || null;
	const base64content = file.split(',')[1] || null;
	const size = getBase64FileSize(file);

	return { size, mimeType, base64content };
};

export const parseBase64EncodedJson = (base64String: string): any | null =>
	base64String ? JSON.parse(Buffer.from(base64String, 'base64').toString('utf-8')) : null;
